exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.more-messages {\n\tposition: -webkit-sticky;\n\tposition: sticky;\n\tbottom: 0px;\n\tbackground-color: rgba(0,0,0,0.3);\n\ttext-align: center;\n\tcolor: white;\n\tpadding: 5px;\n\tborder-radius: 5px;\n}\n", ""]);

// exports
